export default __webpack_public_path__ + "static/media/banner1.9bcda826.jpg";